<template>
    <el-link v-bind="$attrs" :type="type" :underline="underline" :disabled="disabled" @click.native.stop="onClick">
        <template v-if="icon">
            <i :class="[icon, 'primaryColor mr5']"></i>
        </template>
        <slot>{{ label }}</slot>
    </el-link>
</template>

<script>
    import { debounce } from 'lodash';
    export default {
        props: {
            type: {
                type: String,
                default: 'primary'
            },
            underline: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: ''
            },
            download: {
                type: String,
                default: ''
            },
            icon: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {}
        },
        methods: {
            onClick: debounce(function() {
                if (this.disabled) {
                    return;
                }
                if (this.download) {
                    // 处理下载
                    window.open(this.download);
                } else {
                    this.$emit('click');
                }
            }, 200)
        }
    }
</script>

<style scoped>

</style>
